<form #formEl [formGroup]="riskForm" class="left">
  <wz-form-group
    [expandable]="true"
    [expanded]="true"
    [formGroupControl]="assureInfo.formGroup"
    [disabled]="disabled"
  >
    <wz-form-group-header>
      <mat-icon>person</mat-icon>Informations sur l'assuré
      <wz-info-tooltip
        [outline]="true"
        message="Informations sur l'assuré"
      ></wz-info-tooltip>
    </wz-form-group-header>
    <wz-assure-info-form
      #assureInfo
      (zipCodeChange)="onZipCodeChange($event)"
    ></wz-assure-info-form>
  </wz-form-group>
  <wz-form-group
    [expandable]="true"
    [expanded]="expandGroups"
    [formGroupControl]="bestCarPicker.carGroup"
    [disabled]="disabled"
  >
    <wz-form-group-header>
      <mat-icon>directions_car</mat-icon>Véhicule à assurer
      <ng-container *ngIf="!isTunnelApp"
        >(Pensez à cliquer sur le bouton "Valider le véhicule")</ng-container
      >
    </wz-form-group-header>
    <wz-car-picker #bestCarPicker formControlName="car" [zipCode]="zipCode">
    </wz-car-picker>
  </wz-form-group>
  <wz-form-group
    [expandable]="true"
    [expanded]="expandGroups"
    [formGroupControl]="infosForm.formGroup"
    [disabled]="disabled"
  >
    <wz-form-group-header>
      <mat-icon>directions_car</mat-icon>Informations sur l'usage du véhicule
    </wz-form-group-header>
    <wz-infos-form
      #infosForm
      (usageChange)="onUsageChange($event)"
      [zipCode]="zipCode"
    ></wz-infos-form>
  </wz-form-group>

  <wz-form-group
    [expandable]="true"
    [expanded]="expandGroups"
    [hidden]="!withSubscription"
    [formGroupControl]="subInfo.formGroup"
    [disabled]="disabled"
  >
    <wz-form-group-header>
      <mat-icon>insert_drive_file</mat-icon>Informations supplémentaires
    </wz-form-group-header>
    <wz-car-quotation-subscription-form
      #subInfo
      [policyCreationDate]="policyCreationDate"
      (effectDateChange)="onEffectDateChange($event)"
    >
    </wz-car-quotation-subscription-form>
  </wz-form-group>
</form>
